import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'sh-inputs-controls',
  templateUrl: './form-controls.component.html',
  styleUrl: './form-controls.component.scss',
  standalone: false
})
export class FormControlsComponent implements OnInit {
  emailForm: UntypedFormGroup = new UntypedFormGroup({});
  get email(): UntypedFormControl {
    return this.emailForm.get('email') as UntypedFormControl;
  }

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.emailForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email
        ]
      ]
    });
  }
}
